import i18n from 'i18next'
// import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import translations from 'app-view/translations'

// https://www.i18next.com/overview/configuration-options
i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: translations,
    fallbackLng: 'en',
    debug: typeof process !== 'undefined' && process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  })

i18n.languages = ['en', 'cn', 'es', 'vi', 'id']
// https://github.com/isaachinman/next-i18next/issues/374

export default i18n
